import React from 'react';

function Subscriber() {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='8' fill='#F9F0FF' />
      <path
        d='M22.6002 17.5452C23.7619 18.4132 24.8002 20.5986 24.8002 21.9451C24.8002 22.3646 24.4941 22.7047 24.1166 22.7047H23.7002M19.3002 13.9874C20.0517 13.5526 20.5573 12.7401 20.5573 11.8095C20.5573 10.8788 20.0517 10.0663 19.3002 9.63153M7.88382 22.7047H19.9261C20.3037 22.7047 20.6097 22.3646 20.6097 21.9451C20.6097 19.3082 18.4067 17.1706 13.905 17.1706C9.40319 17.1706 7.2002 19.3082 7.2002 21.9451C7.2002 22.3646 7.50626 22.7047 7.88382 22.7047ZM16.4192 11.8095C16.4192 13.1981 15.2936 14.3237 13.905 14.3237C12.5164 14.3237 11.3907 13.1981 11.3907 11.8095C11.3907 10.4209 12.5164 9.29517 13.905 9.29517C15.2936 9.29517 16.4192 10.4209 16.4192 11.8095Z'
        stroke='#722ED1'
        stroke-width='1.8'
        stroke-linecap='round'
      />
    </svg>
  );
}

export default Subscriber;
